import React from "react";
import { ReactComponent as LargeShopifyLoader } from "../../assets/images/LargeShopifyLoader.svg";

import { SHOPIFY_ENV } from "../../utils";
import { usePublicConfig } from "../../hooks/usePublicConfig";

import { Container, Loader, Text, Wrapper } from "./styles";

const LoadingModal = ({ isLoading }) => {
  const { env } = usePublicConfig();
  const isShopify = SHOPIFY_ENV.includes(env?.hostEnv);

  if (isLoading) {
    return (
      <Container loading={isLoading ? 1 : 0} $isShopify={isShopify}>
        <Wrapper>
          {isShopify ? (
            <div className="sp-loader">
              <LargeShopifyLoader />
            </div>
          ) : (
            <>
              <Loader />
              <Text>Please wait...</Text>
            </>
          )}
        </Wrapper>
      </Container>
    );
  }

  return null;
};

export default LoadingModal;
